define(function(require, exports, module) {
    'use strict';
    var AuthManager = require('managers/auth.manager');

    module.exports = new AuthManager();
});

